// extracted by mini-css-extract-plugin
export default {"alert":"AccountPortalBanner_alert__FfLb7","link":"AccountPortalBanner_link__cOzuW"};